import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getItems } from "../api/api";

function ShoppingList({ onDelete, onUpdateQuantity, remainingBudget }) {
  const [items, setItems] = useState([]);

  const fetchItems = () => {
    getItems()
      .then((res) => setItems(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchItems();
  }, [remainingBudget]);

  const handleDelete = (item) => {
    onDelete(item.id, item.quantity * item.price);
  };

  const toggleBought = (id) => {
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, bought: !item.bought } : item
      )
    );
  };

  return (
    <div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#4CAF50", color: "white" }}>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Item</th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Quantity</th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Total</th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Bought</th>
            <th style={{ padding: "10px", border: "1px solid #ddd" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr
              key={item.id}
              style={{
                backgroundColor: "#f9f9f9",
                textAlign: "center",
                textDecoration: item.bought ? "line-through" : "none",
                opacity: item.bought ? 0.6 : 1,
              }}
            >
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                {item.itemName}
              </td>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                <div style={{ display: "flex", gap: "5px", justifyContent: "center", alignItems: "center" }}>
                  <button
                    onClick={() => {
                      if (item.quantity > 1) {
                        onUpdateQuantity(item, item.quantity - 1);
                      }
                    }}
                    style={{
                      padding: "3px 8px",
                      backgroundColor: "#ff9800",
                      color: "white",
                      border: "none",
                      borderRadius: "3px",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                  >
                    −
                  </button>
                  <span style={{ minWidth: "30px", textAlign: "center" }}>{item.quantity}</span>
                  <button
                    onClick={() => {
                      onUpdateQuantity(item, item.quantity + 1);
                    }}
                    style={{
                      padding: "3px 8px",
                      backgroundColor: "#4CAF50",
                      color: "white",
                      border: "none",
                      borderRadius: "3px",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                  >
                    +
                  </button>
                </div>
              </td>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                {item.quantity * item.price}
              </td>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                <input
                  type="checkbox"
                  checked={item.bought || false}
                  onChange={() => toggleBought(item.id)}
                />
              </td>
              <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                <button
                  onClick={() => handleDelete(item)}
                  style={{
                    padding: "5px 10px",
                    backgroundColor: "#f44336",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ShoppingList;

ShoppingList.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onUpdateQuantity: PropTypes.func.isRequired,
  remainingBudget: PropTypes.number.isRequired,
};
